import { Component, OnInit } from '@angular/core';
import { ReportService } from '../../../report.service';
import { ActivatedRoute } from '@angular/router';
import * as utf8 from 'crypto-js/enc-utf8';
import AES = require('crypto-js/aes');
import { environment } from '../../../../../../environments/environment';
import { UserProfile } from '../../../../../models/user-profile.model';
import { UtilService } from '../../../../../service/util.service';
import { ToastController } from '@ionic/angular';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-report-proposal-detail',
  templateUrl: './report-proposal-detail.page.html',
  styleUrls: ['./report-proposal-detail.page.scss'],
})
export class ReportProposalDetailPage implements OnInit {

  token: any;
  userProfile: UserProfile = new UserProfile();
  proposalNumber: any;
  proposal:any=[];
  constructor(
    private reportService: ReportService,
    private activeRoute: ActivatedRoute,
    private utilService :UtilService,
    private toastCtrl:ToastController
  ) { }

  ngOnInit() {
    this.getData();
  }
  getData() {
  this.proposal.detail = [];
    this.activeRoute.queryParams.subscribe((snapshot) => {
      let myKey=environment.myKey;
      this.proposalNumber = AES.decrypt(snapshot.i, myKey).toString(utf8);
      this.proposalNumber = this.proposalNumber.replaceAll('"','');
      let options = {
        "token": this.token,
        "proposal_number":this.proposalNumber,
        "counter_id": this.userProfile.counter_id !== 0 ? this.userProfile.counter_id : this.userProfile.counter_id_list
      };
      this.reportService.getProposalReportDetail(options)
      .subscribe((response) => {
        this.utilService.loadingDismiss();
         if(response.status.code === 200) {
          this.proposal = response.data;
          console.log(this.proposal)
        } else {
          this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
        }
      }, () => {
        this.utilService.loadingDismiss();
        this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
      });
    });
  }
  exportExcel() {

      if (!this.proposal) {
          return;
      }


      // ==========================
      // HEADER PROPOSAL
      // ==========================

      const proposalInfo = [

          ['PROPOSAL REPORT'],

          [''],

          ['Proposal Number', this.proposal.proposal_number],

          ['Product Request', this.proposal.id],

          ['Start Date', this.proposal.proposal_start_date],

          ['End Date', this.proposal.proposal_end_date],

          ['Status', this.proposal.status_proposal],

          [''],

          ['Total Qty', Number(this.proposal.total_qty)],

          ['Fulfilled Qty', Number(this.proposal.fulfilled_qty)],

          ['Remaining Qty', Number(this.proposal.remaining_qty)],

          [
              'Fulfillment Percentage',
              Number(this.proposal.fulfillment_percentage) / 100
          ],

          [''],

          ['DETAIL PEMENUHAN']

      ];


      // ==========================
      // DETAIL HEADER
      // ==========================

      const detailHeader = [

          'No',
          'Pcode',
          'Product Name',
          'Qty Proposal',
          'PR',
          'Qty Request'

      ];


      // ==========================
      // DETAIL DATA
      // ==========================

      const detailData = [];

      if (
          this.proposal.detail &&
          this.proposal.detail.length > 0
      ) {

          for (
              let i = 0;
              i < this.proposal.detail.length;
              i++
          ) {

              const item =
                  this.proposal.detail[i];


              const qtyProposal =
                  Number(item.qty_proposal) || 0;


              const qtyRequest =
                  Number(item.qty_request) || 0;


              const fulfillment =
                  qtyProposal > 0
                      ? qtyRequest / qtyProposal
                      : 0;


              detailData.push([

                  i + 1,

                  item.product_id ,
                  item.product_name,

                  qtyProposal,

                  item.pr_id,

                  qtyRequest

              ]);

          }

      }


      // ==========================
      // GABUNGKAN DATA
      // TANPA SPREAD OPERATOR
      // ==========================

      const excelData = [];


      // Proposal information
      for (
          let i = 0;
          i < proposalInfo.length;
          i++
      ) {

          excelData.push(
              proposalInfo[i]
          );

      }


      // Detail header
      excelData.push(
          detailHeader
      );


      // Detail data
      for (
          let i = 0;
          i < detailData.length;
          i++
      ) {

          excelData.push(
              detailData[i]
          );

      }


      // ==========================
      // WORKSHEET
      // ==========================

      const worksheet: XLSX.WorkSheet =
          XLSX.utils.aoa_to_sheet(
              excelData
          );


      // ==========================
      // COLUMN WIDTH
      // ==========================

      worksheet['!cols'] = [

          { wch: 8 },
          { wch: 25 },
          { wch: 18 },
          { wch: 22 },
          { wch: 18 },
          { wch: 18 }

      ];


      // ==========================
      // FORMAT PERCENTAGE
      // ==========================

      // Summary fulfillment
      if (worksheet['B12']) {

          worksheet['B12'].z =
              '0.00%';

      }




      // ==========================
      // WORKBOOK
      // ==========================

      const workbook: XLSX.WorkBook =
          XLSX.utils.book_new();


      XLSX.utils.book_append_sheet(

          workbook,

          worksheet,

          'Proposal Detail'

      );


      // ==========================
      // FILE NAME
      // ==========================

      let proposalNumber =
          'Proposal';


      if (
          this.proposal.proposal_number
      ) {

          proposalNumber =
              this.proposal.proposal_number;

      }


      XLSX.writeFile(

          workbook,

          proposalNumber + '_Detail.xlsx'

      );

  }
}
